const observers = {};

function handleIntersection(namespace, entries) {
  if (!observers[namespace]) return;

  const { targets } = observers[namespace];
  entries.forEach((entry) => {
    const { callback } = targets.find(t => t.target === entry.target) || {};
    if (callback) callback(entry);
  });
}

export function observe(target, namespace, callback, options) {
  if (!observers[namespace]) {
    observers[namespace] = {
      observer: new IntersectionObserver(
        entries => handleIntersection(namespace, entries), options,
      ),
      targets: [],
    };
  }

  const { observer, targets } = observers[namespace];
  targets.push({ target, callback });
  observer.observe(target);
}

export function unobserve(target, namespace) {
  if (!observers[namespace]) return;

  const { observer, targets } = observers[namespace];
  const targetIndex = targets.findIndex(t => t.target === target);
  if (targetIndex === -1) return;

  observer.unobserve(target);
  targets.splice(targetIndex, 1);

  if (targets.length === 0) {
    observer.disconnect();
    delete observers[namespace];
  }
}

export function isIntersecting(entry) {
  return entry.isIntersecting === undefined || entry.isIntersecting;
}
